/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Stack, SxProps, Theme } from "@mui/material";
import { mobileNavStyle } from "@/src/components/Header/MobileNav/mobileNavStyle.ts";
import { mergeSx } from "@/src/utils/mergeSx.ts";
import { NavigationItemTypes } from "@/src/types/Navigation.ts";
import { ReactNode } from "react";
import NavItem from "@/src/components/Header/NavItem/NavItem.tsx";

export type MobileNavProps = {
  active?: boolean;
  items?: NavigationItemTypes[] | null;
  mobileNavComp?: ReactNode;
  actions?: ReactNode;
  id: string;
  sx?: SxProps<Theme>;
};

export default function MobileNav({ id, active, items, sx, actions, mobileNavComp }: MobileNavProps) {
  const hasNavComp = !!mobileNavComp;

  return (
    <Stack
      component={hasNavComp ? "div" : "nav"}
      sx={mergeSx(mobileNavStyle.mobileNav, hasNavComp && mobileNavStyle.withNavComp, active && mobileNavStyle.active, sx)}
      useFlexGap
      id={id}
      inert={!active}
    >
      {hasNavComp ? (
        mobileNavComp
      ) : (
        <>
          <Stack component={"ul"} sx={{ listStyle: "none", padding: 0, margin: 0, flexGrow: 1, overflow: "auto" }}>
            {items?.map((item) => {
              return (
                <NavItem
                  key={item.label}
                  {...(item.type === "category"
                    ? {
                        ...item,
                        isMobileNav: true,
                      }
                    : item)}
                />
              );
            })}
          </Stack>
          {!!actions && actions}
        </>
      )}
    </Stack>
  );
}
